import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY;
const center = {
    lat: -26.0103375,
    lng: 27.9818155,
};
export function useAddAddressState() {
    const [map, setMap] = useState(null);
    const { control, formState: { isValid }, handleSubmit: submitForm, register, setValue, watch, } = useForm({
        mode: "all",
        defaultValues: {
            full_address: "",
            apartment_number: "",
            city: "",
            notes: "",
            label: "",
            line_one: "",
            type: "House",
            postal_code: "",
            latitude: center?.lat,
            longitude: center?.lng,
        },
    });
    const type = watch("type");
    const hasErrors = useMemo(() => !isValid, [isValid]);
    const handleLoad = useCallback((map) => {
        setMap(map);
    }, []);
    const handleUnmount = useCallback(function callback(map) {
        setMap(null);
    }, []);
    const handleTypeChanged = useCallback((value) => () => {
        setValue("type", value);
    }, []);
    register("full_address", { required: { value: true, message: "Please provide your Full Address" } });
    register("apartment_number", { required: false });
    register("city", { required: { value: true, message: "Please provide a valid City" } });
    register("notes", { required: false });
    register("line_one", { required: { value: true, message: "Please provide a valid Street Address" } });
    register("label", { required: { value: true, message: "Please provide a friendly label for this Address" } });
    register("type", { required: false });
    register("postal_code", { required: { value: true, message: "Please provide a valid Zip Code" } });
    register("latitude", { required: false });
    register("longitude", { required: false });
    useEffect(() => {
        if (!!map && map?.center) {
            setValue("latitude", map?.center?.lat());
            setValue("longitude", map?.center?.lng());
        }
    }, [map]);
    return useMemo(() => ({
        center,
        control,
        handleLoad,
        handleTypeChanged,
        handleUnmount,
        hasErrors,
        submitForm,
        type,
    }), [center, control, handleLoad, handleTypeChanged, handleUnmount, hasErrors, submitForm, type]);
}
